import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPSetting } from '@fitness-force/models';
import { environment } from 'apps/ff-frontend/src/environments/environment';


@Injectable({
  providedIn: 'root',
})
export class LocationService {
  IP_API_URL: string = environment.Ip_Api_URL;
  config = { url: environment.IPinfoURL, token: environment.IPinfoToken };
  constructor(private http: HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'allow-origin': '*',
      'allow-corss-origin': '*'
    }),
  };


  getIpData() {
    let ip = false; // tem: could be modified to get info about IP address..
    return this.http.get<any>(
      this.base +
      (ip ? '/' + ip : '') +
      '/geo' +
      ((this.config && '?token=' + this.config.token) || '')
    );
  }

  private get base(): string {
    // Makes sure the baser url always ends up clean
    return (
      (this.config &&
        (this.config.url && this.config.url.endsWith('/')
          ? this.config.url.slice(0, -1)
          : this.config.url)) ||
      'https://ipinfo.io'
    );
  }




  getPosition(): Promise<IPSetting> {
    return new Promise((resolve, reject) => {
      this.getIpData().subscribe({
        next: (res: IPSetting | PromiseLike<IPSetting>) => {
          resolve(res);
        }, error: (error) => {
          reject(error);
        }
      });
    });
  }

}
